import InicioQuestionario from '@/components/InformationSuitability/InicioQuestionario'
import AvaliacaodeRisco from '@/components/InformationSuitability/AvaliacaodeRisco'
import AceiteConfirmacao from '@/components/InformationSuitability/AceiteConfirmacao'
import ConfirmacaoPerfil from '@/components/InformationSuitability/ConfirmacaoPerfil'


const steps = {
    'inicio-questionario-step': InicioQuestionario,
    'avalicao-de-risco-step': AvaliacaodeRisco,
    'aceite-step': AceiteConfirmacao,
    'confirmacao-step': ConfirmacaoPerfil,
}
export default steps



// WEBPACK FOOTER //
// ./src/components/InformationSuitability/index.js